// src/components/TestBackendPage.jsx
import React from 'react';
import IfceHorseSearch from './IfceHorseSearch';

export default function TestBackendPage() {
  return <IfceHorseSearch />;
}
